import { probability_score } from "../stores/consequence-severity-table";

export function enrichIncidentPotentialRisks(
	potentialRisks: any[] | undefined
) {
	return Array.isArray(potentialRisks)
		? potentialRisks.map((riskItem: any) => {
				const score = `${riskItem?.severity_level ?? ""}${
					riskItem?.probability ?? ""
				}`;
				const riskScore = Object.entries(probability_score).find(([, list]) =>
					list.includes(score)
				)?.[0];
				return {
					...riskItem,
					risk: riskScore ? `${score} - ${riskScore}` : null,
				};
			})
		: [];
}

export function enrichIncidentData(data: any) {
	if (!data) return data;
	if (data.report_type === "incident_report") {
		return {
			...data,
			potential_risks: enrichIncidentPotentialRisks(data?.potential_risks),
		};
	}
	return data;
}
